module.exports = __webpack_public_path__ + "media/images/japan/place_3-ae4fed626f88aeb4c7e396d6a7702a66.png";